import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

function FAQ({ faqs, limit }) {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (id) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  const displayedFaqs = limit ? faqs.slice(0, limit) : faqs;

  return (
    <div className="space-y-4">
      {displayedFaqs.map((faq, index) => (
        <div key={faq.id} className="relative border border-border-subtle rounded-lg overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <span className="absolute top-1/2 left-5 -translate-y-1/2 text-7xl font-extrabold text-white opacity-5">
              {index + 1}
            </span>
          </div>

          <button
            className="w-full flex justify-between items-center p-5 text-lg font-semibold text-text-white bg-white/5 hover:bg-white/10 focus:outline-none relative z-10 text-left" // Added text-left
            onClick={() => toggleFAQ(faq.id)}
            aria-expanded={openFAQ === faq.id}
            aria-controls={`faq-content-${faq.id}`}
          >
            {faq.question}
            <FontAwesomeIcon
              icon={openFAQ === faq.id ? faChevronUp : faChevronDown}
              className="text-accent-red ml-4"
            />
          </button>
          {openFAQ === faq.id && (
            <div
              id={`faq-content-${faq.id}`}
              className="p-5 bg-white/5 border-t border-border-subtle text-text-gray relative z-10"
            >
              <p>{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default FAQ;